import * as PATHS from 'js/constants/pathnames';
import AddDataSourceFormContainer from 'js/components/data_sources/AddDataSourceFormContainer';
import { ScreenComponent } from 'new/routes/RouterManager';
import AsyncViewDataSourcesContainer from 'js/components/data_sources/ViewDataSourcesContainer';
import SendDataFormContainer from 'js/components/sendData/SendDataFormContainer';
import DestinationSetupContainer from 'js/components/destination/DestinationSetupContainer';
import ViewDataSetsContainer from 'js/components/data_sets/ViewDataSetsContainer';
import AsyncViewDataSinksContainer from 'js/components/data_sinks/ViewDataSinksContainer';
import PipelineFormContainer from 'js/components/pipelines/PipelineFormContainer';
import PipelinesContainer from 'js/components/pipelines/PipelinesContainer';
import DataMapsEditFormContainer from 'js/components/data_maps/DataMapsEditFormContainer';
import AsyncDataMapDashboardContainer from 'js/components/data_maps/DataMapDashboardContainer';
import ViewCredentialsContainer from 'js/components/credentials/ViewCredentialsContainer';
import ViewAPIKeysContainer from 'js/components/apiKeys/ViewAPIKeysContainer';
import { EditErrorDataSettings } from 'new/components/monitor/EditErrorDataSettings';
import { ErrorDataSettings } from 'new/components/monitor/ErrorDataSettings';
import RecordLineageContainer from 'js/components/recordLineage/RecordLineageContainer';
import UserPage from 'new/components/settings/userPage/UserPage';
import { NotificationSettings } from 'new/components/monitor/NotificationSettings';
import ReusableTransformsDashboard from 'js/components/reusableTransforms/ReusableTransformsDashboard';
import SchemaSpecsDashboard from 'js/components/schemaSpecs/SchemaSpecsDashboard';
import { ResourceTriage } from 'new/components/monitor/ResourceTriage';

export const oldToNewMap = {
  ['/dashboard']: '/',
  [`${PATHS.ROUTE_DATA_SETS_SHARED_WITH_ME}`]: (
    ViewDataSetsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.ROUTE_DATA_SOURCES}/:id/edit`]: (
    AddDataSourceFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[1],
  [`${PATHS.ROUTE_DATA_SOURCES}/new`]: (
    AddDataSourceFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.ROUTE_MY_DATA_SETS}/:id/edit`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[1],
  [`${PATHS.ROUTE_MY_DATA_SETS}/:id/new`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.ROUTE_DATA_SOURCES}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_sources&id=:id',
  [`${PATHS.ROUTE_DATA_SOURCES}`]: (
    AsyncViewDataSourcesContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[1],
  [`${PATHS.ROUTE_DATA_SETS_SHARED_WITH_ME}/:id/new`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[2],
  [`${PATHS.ROUTE_DATA_SETS_SHARED_WITH_ME}/:id/send`]: (
    DestinationSetupContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[2],
  [`${PATHS.ROUTE_DATA_SETS_SHARED_WITH_ME}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_sets&id=:id',
  [`${PATHS.OLD_V2_ROUTE_MY_DATA_SETS}/:id/edit`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[1],
  [`${PATHS.OLD_V2_ROUTE_MY_DATA_SETS}/:id/new`]: (
    ViewDataSetsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.OLD_V2_ROUTE_MY_DATA_SETS}/:id/send`]: (
    DestinationSetupContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.OLD_V2_ROUTE_MY_DATA_SETS}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_sets&id=:id',
  [`${PATHS.OLD_V2_ROUTE_MY_DATA_SETS}`]: (ViewDataSetsContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.ROUTE_MY_DATA_SETS}`]: (ViewDataSetsContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.OLD_V2_ROUTE_DATA_SETS_SHARED_WITH_ME}/:id/new`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[2],
  [`${PATHS.OLD_V2_ROUTE_DATA_SETS_SHARED_WITH_ME}/:id/send`]: (
    DestinationSetupContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[2],
  [`${PATHS.OLD_V2_ROUTE_DATA_SETS_SHARED_WITH_ME}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_sets&id=:id',
  [`${PATHS.OLD_V2_ROUTE_DATA_SETS_SHARED_WITH_ME}`]: (
    ViewDataSetsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.OLD_ROUTE_DATA_SETS_PUBLIC}/:id/new`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[2],
  [`${PATHS.OLD_ROUTE_DATA_SETS_PUBLIC}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_sets&id=:id',
  [`${PATHS.OLD_ROUTE_DATA_SETS_PUBLIC}`]: (
    ViewDataSetsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.OLD_ROUTE_DATA_SETS_FROM_MY_DATA}/:id/new`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[2],
  [`${PATHS.OLD_ROUTE_DATA_SETS_FROM_MY_DATA}/:id`]: (
    ViewDataSetsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.OLD_ROUTE_DATA_SETS_FROM_MY_DATA}`]: (
    ViewDataSetsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.OLD_ROUTE_DATA_SETS_DERIVED}/:id/new`]: (
    SendDataFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[2],
  [`${PATHS.OLD_ROUTE_DATA_SETS_DERIVED}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_sets&id=:id',
  [`${PATHS.OLD_ROUTE_DATA_SETS_DERIVED}`]: (
    ViewDataSetsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.ROUTE_DATA_SETS}/:id`]: ResourceTriage.screenConfig.path + '?type=data_sets&id=:id',
  [`${PATHS.ROUTE_DATA_SETS}`]: (ViewDataSetsContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.OLD_V2_ROUTE_DATA_SETS}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_sets&id=:id',
  [`${PATHS.OLD_V2_ROUTE_DATA_SETS}`]: (ViewDataSetsContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.ROUTE_DESTINATIONS}/:id/edit`]: (
    DestinationSetupContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[1],
  [`${PATHS.ROUTE_DESTINATIONS}`]: (AsyncViewDataSinksContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.ROUTE_DESTINATIONS}/:id`]: ResourceTriage.screenConfig.path + '?type=data_sinks&id=:id',
  [`${PATHS.ROUTE_PIPELINES}/new`]: (AsyncViewDataSinksContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[1],
  [`${PATHS.ROUTE_PIPELINES}/:id/edit`]: (PipelineFormContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.ROUTE_PIPELINES}/:id`]: (PipelinesContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[1],
  [`${PATHS.ROUTE_PIPELINES}`]: (PipelinesContainer as unknown as ScreenComponent<any>).screenConfig
    .path[0],
  [`${PATHS.ROUTE_REUSABLE_TRANSFORMS}/:id`]:
    (ReusableTransformsDashboard as unknown as ScreenComponent<any>).screenConfig.path + '/:id',
  [`${PATHS.ROUTE_REUSABLE_TRANSFORMS}`]: (
    ReusableTransformsDashboard as unknown as ScreenComponent<any>
  ).screenConfig.path,
  [`${PATHS.ROUTE_SCHEMA_SPECS}`]: (SchemaSpecsDashboard as unknown as ScreenComponent<any>)
    .screenConfig.path,
  [`${PATHS.ROUTE_SCHEMA_SPECS}/:id`]:
    ResourceTriage.screenConfig.path + '?type=data_schemas&id=:id',
  [`${PATHS.ROUTE_DATA_MAPS}`]: (AsyncDataMapDashboardContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[1],
  [`${PATHS.ROUTE_DATA_MAPS}/:id`]: (
    AsyncDataMapDashboardContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[0],
  [`${PATHS.ROUTE_DATA_MAPS}/:id/edit`]: (
    DataMapsEditFormContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[1],
  [`${PATHS.ROUTE_DATA_MAPS}/new`]: (DataMapsEditFormContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.ROUTE_CREDENTIALS}/new`]: (ViewCredentialsContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.ROUTE_CREDENTIALS}`]: (ViewCredentialsContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[3],
  [`${PATHS.ROUTE_CREDENTIALS}/:id`]: (ViewCredentialsContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[2],
  [`${PATHS.ROUTE_CREDENTIALS}/:id/edit`]: (
    ViewCredentialsContainer as unknown as ScreenComponent<any>
  ).screenConfig.path[1],
  [`${PATHS.ROUTE_API_KEYS}`]: (ViewAPIKeysContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[1],
  [`${PATHS.ROUTE_API_KEYS}/:id`]: (ViewAPIKeysContainer as unknown as ScreenComponent<any>)
    .screenConfig.path[0],
  [`${PATHS.ROUTE_ERROR_MANAGEMENT}`]: ErrorDataSettings.screenConfig.path,
  [`${PATHS.ROUTE_ERROR_MANAGEMENT}/config`]: EditErrorDataSettings.screenConfig.path,
  [PATHS.ROUTE_RECORD_LINEAGE]: RecordLineageContainer.screenConfig.path,
  [PATHS.ROUTE_ACCOUNT_MANAGEMENT]: UserPage.screenConfig.path,
  [PATHS.ROUTE_NOTIFICATIONS_MANAGER]: NotificationSettings.screenConfig.path,
} as { [key: string]: string };
